// @flow
import { taskProfile } from 'common/middleware/api';
import { ApiError } from 'common/modules/api';
import { injectError } from 'common/redux/actions/error';

export default class TaskProfileActions {
    static FETCH_TASK_PROFILE_START = 'FETCH_TASK_PROFILE_START';
    static FETCH_TASK_PROFILE_ERROR = 'FETCH_TASK_PROFILE_ERROR';
    static INJECT_TASK_PROFILE = 'INJECT_TASK_PROFILE';

    static fetchTaskProfile(
        clientId: string,
        teamId: string,
        taskProfileId: string
    ) {
        const params = {
            clientId,
            teamId,
            taskProfileId
        };

        return dispatch => {
            taskProfile
                .fetch(params)
                .then(taskProfile => {
                    dispatch(
                        TaskProfileActions.injectTaskProfile(
                            taskProfile,
                            params
                        )
                    );
                })
                .catch(error => {
                    dispatch(TaskProfileActions.completeFetchingTaskProfile());
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static startFetchingTaskProfile(): Object {
        return {
            type: TaskProfileActions.FETCH_TASK_PROFILE_START
        };
    }

    static completeFetchingTaskProfile(): Object {
        return {
            type: TaskProfileActions.FETCH_TASK_PROFILE_ERROR
        };
    }

    static injectTaskProfile(taskProfile, params): Object {
        return {
            type: TaskProfileActions.INJECT_TASK_PROFILE,
            response: taskProfile,
            params
        };
    }
}
